import { ClientCacheState } from '@configcat/sdk'
import type { FeatureFlagClient, FeatureFlagSnapshot } from './client'
import type { FeatureFlagOverrides } from './config'
import type { FeatureFlagKey, FeatureFlagSource, FeatureFlagUser } from './registry'

export type FeatureFlagEvaluation = Readonly<{
  value: boolean
  source: FeatureFlagSource
}>

export function takeFeatureFlagSnapshot(
  client: FeatureFlagClient | undefined,
): FeatureFlagSnapshot | undefined {
  if (client === undefined) {
    return undefined
  }
  try {
    return client.snapshot()
  } catch {
    return undefined
  }
}

export function evaluateFeatureFlag(
  key: FeatureFlagKey,
  snapshot: FeatureFlagSnapshot | undefined,
  overrides: FeatureFlagOverrides,
  user?: FeatureFlagUser,
): FeatureFlagEvaluation {
  if (snapshot) {
    try {
      if (snapshot.cacheState === ClientCacheState.NoFlagData) {
        return { value: false, source: 'default' }
      }
      const details = snapshot.getValueDetails(key, false, user)
      return {
        value: details.value,
        source: details.isDefaultValue ? 'default' : 'configcat',
      }
    } catch {
      return { value: false, source: 'default' }
    }
  }

  if (overrides[key] !== undefined) {
    return { value: overrides[key], source: 'override' }
  }
  return { value: false, source: 'default' }
}
